module.exports = __webpack_public_path__ + "img/SEGURIFY_landing_icono_001_porque.ab376d0f.png";